/**
 * Playlist List Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Playlist List guide.
 */
export const playlistListTourConfig = {
  id: 'playlist-list-onboarding',
  storageKey: 'triad_tour_playlist_list_completed',
  steps: [
    {
      id: 'playlist-add-btn',
      target: '[data-tour="playlist-add-btn"], [data-tour="crud-add-btn"]',
      titleKey: 'tour.playlistList.addTitle',
      descriptionKey: 'tour.playlistList.addDesc',
      position: 'bottom',
      align: 'end'
    },
    {
      id: 'playlist-search-input',
      target: '[data-tour="playlist-search-input"], [data-tour="crud-search-input"]',
      titleKey: 'tour.playlistList.searchTitle',
      descriptionKey: 'tour.playlistList.searchDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'playlist-table',
      target: '[data-tour="playlist-table"], [data-tour="crud-table"]',
      titleKey: 'tour.playlistList.tableTitle',
      descriptionKey: 'tour.playlistList.tableDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default playlistListTourConfig;
